import detectIt from 'detect-it'

let { hasMouse, primaryInput } = detectIt

// Toggle main navigation for small screens

function main () {
  const HIDDEN = 'none'
  const MUTE = 'o-10'
  let $toggle = document.querySelector('[aria-controls="menu-list"]')
  let $menu = document.getElementById('menu-list')
  let $main = document.querySelector('main')

  $toggle.addEventListener('click', function () {
    if ($menu.classList.contains(HIDDEN)) {
      expand()
    } else {
      collapse()
    }
  })

  function expand () {
    $toggle.setAttribute('aria-expanded', true)
    $menu.classList.remove(HIDDEN)
    $main.classList.add(MUTE)
  }

  function collapse () {
    $toggle.setAttribute('aria-expanded', false)
    $menu.classList.add(HIDDEN)
    $main.classList.remove(MUTE)
  }
}

// Toggle submenus

function submenu () {
  const INVISIBLE = 'invisible-md'
  let $elements = document.querySelectorAll('[data-module="submenu"]')
  let $menu = document.getElementById('menu-list')

  for (let i = 0; i < $elements.length; i++) {
    setup($elements[i])
  }
  
  function setup ($element) {
    let $toggle = $element.previousElementSibling

    if (!$toggle) return

    $toggle.addEventListener('click', function (event) {
      event.preventDefault()
      $element.classList.toggle(INVISIBLE)
    })
    collapse()

    // Handle "hover" too :-/
    if (hasMouse && primaryInput === 'mouse') {
      $toggle.addEventListener('mouseover', onEnter, false)
    }
  
    function onEnter () {
      if ($element.classList.contains(INVISIBLE)) {
        expand()

        $element.addEventListener('mouseleave', function onLeave () {
          collapse()
          $element.removeEventListener('mouseleave', onLeave)
        })

        $menu.addEventListener('mouseover', function onOver (event) {
          let target = event.target
          if (!$toggle.parentElement.contains(target)) {
            collapse()
            $menu.removeEventListener('mouseover', onOver)
          }
        })
      }
    }

    function expand () {
      $element.classList.remove(INVISIBLE)
    }
    function collapse () {
      $element.classList.add(INVISIBLE)
    }
  }
}

export default function () {
  main()
  submenu()
}
